// 减法 精度换算
const i2Sub = function (n1, n2) {
  const num1 = Number(n1) || 0
  const num2 = Number(n2) || 0
  let r1, r2, m, n
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  n = Math.max(r1, r2)
  m = Math.pow(10, n)
  return Number(((num1 * m - num2 * m) / m).toFixed(n))
}

export default i2Sub
